export default [
    {
        path: "/task",
        name: "task",
        component: () => import("@/views/task/task.vue"),
        meta: {
            title: '任务中心'
        },
    },
    {
        path: "/task/taskDetails",
        name: "/task/taskDetails",
        component: () => import("@/views/task/views/taskDetails.vue"),
        meta: {
            title: '任务中心'
        },
    },
    {
        path: "/task/addTask",
        name: "/task/addTask",
        component: () => import("@/views/task/views/addTask.vue"),
        meta: {
            title: '发布任务'
        },
    },
    {
        path: "/task/userTask",
        name: "/task/userTask",
        component: () => import("@/views/task/views/userTask.vue"),
        meta: {
            title: '个人任务'
        },
    },
]